<template>
	<div>
		<myheader :backFlag="true" headTitle="存证查验"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div class="text12 textcolor333">
						区块链基于电子签约平台合同签约全流程上链数据、生成电子数据存证证明。支持上传区块链电子CA合同或输入存证编号进行在线查验，查验合同的有效性和未篡改性。</div>
					<div class="text14 textcolor999 margin_top_5">查验方式</div>
					<div class="all_height_line24 margin_top_5">
						<span class="all_height_line24 text14 all_text_center left_border_radius"
							style="display: inline-block; width: 50%;" @click="selectVeritStyle(true)"
							:style="{color:selectFlag?'white':'black',backgroundColor:selectFlag?'#0277FC':'#f2f2f2'}">存证文档查验</span>
						<span class="all_height_line24 text14 all_text_center right_border_radius"
							style="display: inline-block; width: 50%;" @click="selectVeritStyle(false)"
							:style="{color:!selectFlag?'white':'black',backgroundColor:!selectFlag?'#0277FC':'#f2f2f2'}">存证编号查验</span>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_5">
					<div class="text14 textcolor333">{{selectFlag?'请上传需要查验的合同文件':'请输入需要查验的存证编号'}}</div>
					<div v-show="this.selectFlag" class="all_text_center margin_top_10">
						<van-uploader accept="application/pdf" v-model="pdfFiles" :before-read="beforeRead"
							:after-read="afterRead">
							<div v-show="pdfFiles.length==0" class="display_flex all_text_center"
								style="padding: 0 .5rem;border-radius: .1rem;border: 1px solid #ccc;">
								<img src="@/assets/images/upload_file.svg" style="height: .8rem; margin: .5rem;" />
								<div class="all_height_line18 text14 textcolor666">
									上传文件
								</div>
							</div>
						</van-uploader>
					</div>
					<!-- <input accept="application/pdf," capture="camera" v-show="this.selectFlag"
						class="all_height_line24 text14 textcolor666 margin_top_10 all_text_center" type="file"
						@click="uploadFile()">上传文件<input /> -->
					<!-- <div v-show="this.selectFlag" class="all_height_line24 text14 textcolor666 margin_top_10 all_text_center" @click="uploadFile()">上传文件</div> -->
					<div v-show="!this.selectFlag" class="text14 textcolor666 margin_top_10">存证编号</div>
					<!-- <div v-show="!this.selectFlag" :class="{ isfocus: nuFocus }"> -->
					<div v-show="!this.selectFlag" class="all_van_field" :class="{ isfocus: nuFocus }">
						<!-- <input class="my_input all_height_line20 text14 textcolor333" -->
						<!-- <textarea class="text14 textcolor333" rows="2" cols="42" style="padding: .3rem .5rem;"
							v-model="veritNumber" @focus="getFocus()" @blur="onblur()" /> -->
						<van-field v-model="veritNumber" rows="1" autosize type="textarea" placeholder="请输入存证编号"
							clearable @focus="getFocus()" @blur="onblur()" maxlength="90"
							@keydown.enter="uploadVerit()" />
					</div>
				</div>
				<div style="width: 100%;margin-top: 3rem;margin-bottom: .5rem;" id="showBottom">
					<button class="all_button22 text14 bmain_active" style="width: 100%;"
						@click="uploadVerit()">查&nbsp;&nbsp;验</button>
				</div>
			</div>
			<!-- 需要按钮随键盘上移时使用并监听键盘弹出 -->
			<!-- <div style="position: absolute;bottom:3rem;left 0rem; width: 100%;padding: 0 5%;">
				<button class="all_button24 text16" style="width: 100%;" @click="uploadVerit()">查&nbsp;&nbsp;验</button>
			</div> -->
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		POSTFILE
	} from '../../utils/http.js'
	import {
		Uploader,
		Field
	} from 'vant';
	export default {
		name: 'certificateverification',
		components: {
			[Uploader.name]: Uploader,
			[Field.name]: Field,
		},
		data() {
			return {
				//true  存证文档查验 false 存证编号查验
				selectFlag: true,
				nuFocus: false,
				//存证编号
				veritNumber: '',
				//选择pdf文件
				pdfFiles: [],
				//屏幕高度
				height: 0,
			};
		},
		methods: {
			//选择查验方式
			selectVeritStyle(flag) {
				if (this.selectFlag != flag) {
					this.selectFlag = flag
				}
			},
			//文件长传前
			beforeRead(file) {
				if (file.type !== 'application/pdf') {
					this.$Toast('请上传pdf文件');
					return false;
				}
				return true;
			},
			//文件长传后
			afterRead(file) {
				console.log(this.pdfFiles)
			},
			//存证查验
			//增加大文件上传，支持最长上传时间10min
			uploadVerit() {
				if (this.selectFlag) {
					if (this.pdfFiles.length > 0) {
						console.log(this.pdfFiles)
						this.$store.dispatch(this.$LoadShow, true)
						this.$post('/evidence/api/checkEvidenceFile', {
								file: this.pdfFiles[0].file,
							}, 'form', 600000)
							.then((res) => {
								this.pdfFiles = []
								this.$store.dispatch(this.$LoadShow, false)
								if (res.success && res.data) {
									this.$store.commit("changeCertVerifInfo", res.data.bc.file)
									this.$router.push({
										path: "/verifdetails",
										query: {
											evidenceCode: res.data.bc.evidenceCode,
											type: '2',
										},
									});
								} else {
									this.$Toast(res.message || res.messageDetail || "上传失败！");
								}
							}).catch((err) => {
								this.$store.dispatch(this.$LoadShow, false)
								this.$Toast("上传失败！");
							})
					} else {
						this.$Toast('请上传要查验的pdf文件')
					}
				} else {
					//console.log('--=' + this.veritNumber)
					this.veritNumber = this.veritNumber.trim()
					if (!this.veritNumber) {
						this.$Toast('请输入查验编号')
						return
					}
					this.$store.dispatch(this.$LoadShow, true)
					this.$get('/evidence/api/getEvidence', {
						code: this.veritNumber
					}).then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.veritNumber = ''
							this.$router.push({
								path: "/verifdetails",
								query: {
									evidenceCode: res.data.evidenceCode,
								},
							});
						} else {
							this.$Toast(res.message || res.messageDetail || "查验失败！");
						}
					}).catch((err) => {
						this.$store.dispatch(this.$LoadShow, false)
						this.$Toast("查验失败！");
					});
				}
			},
			//获取焦点
			getFocus() {
				this.nuFocus = true
			},
			//失去焦点
			onblur() {
				this.nuFocus = false
			},
			//监听高度变化做相应的操作
			makeResize() {
				//键盘弹出
				//console.log('makeResize')
				if (this.height > 0 && document.body.clientHeight < this.height) {
					//console.log('makeResize执行')
					let b = document.getElementById('showBottom')
					b.scrollIntoView()
				}
				if (this.height > 0 && document.body.clientHeight == this.height) {
					//console.log('makeResize等于执行')
				}
			},
		},
		mounted() {
			//console.log('certificate')
			window.addEventListener('resize', this.resize);
			window.addEventListener('resize', this.makeResize);
		},
		computed: {
			//获得高度
			resize() {
				//console.log('resize')
				if (this.height == 0) {
					this.height = document.body.clientHeight
				}
				//console.log(this.height)
			},
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.upload_file::before {
		content: url('../../assets/images/upload_file.svg');
		display: inline-block;
		width: .8rem;
		height: .8rem;
		margin-top: .3rem;
		margin-right: .2rem;
		transform: scale(0.05);
	}

	.left_border_radius {
		border-top-left-radius: .3rem .3rem;
		border-bottom-left-radius: .3rem .3rem;
	}

	.right_border_radius {
		border-top-right-radius: .3rem .3rem;
		border-bottom-right-radius: .3rem .3rem;
	}

	::v-deep .van-cell {
		padding: 10px .3rem;
	}
</style>